export default {
    //recycleScrollerのカラム数設定
    recycleScrollerListColumn: function() {
        if(window.innerWidth > 1074) {
            return 3
        } else {
            return 1
        }
    },
    //chartのラベルの位置設定
    chartLegendDisplay: function() {
        if(window.innerWidth > 1074) {
            return true
        } else {
            return false
        }
    }
}